import { render, staticRenderFns } from "./TicketAdmin.vue?vue&type=template&id=4f9ec6be"
import script from "./TicketAdmin.vue?vue&type=script&lang=js"
export * from "./TicketAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports